import { createSlice } from '@reduxjs/toolkit';
import { IDetailState } from '../interface/IDetail';

const initialState: IDetailState = {
    reload: false,
    detailNow: '',
    detailId: '',
    detailSvr: '',
    detailEnchant: 0,
    serverId: 0,
    shareData: { title: '' },
    itemInfo: null,
    skillInfo: null,
};

export const detailSlice = createSlice({
    name: 'detailSlice',
    initialState: initialState,
    reducers: {
        setReload: (state, action) => {
            state.reload = action.payload;
        },
        setDetailNow: (state, action) => {
            state.detailNow = action.payload;
        },
        setDetailId: (state, action) => {
            state.detailId = action.payload;
        },
        setDetailEnchant: (state, action) => {
            state.detailEnchant = action.payload;
        },
        setDetailSvr: (state, action) => {
            state.detailSvr = action.payload;
        },
        setShareData: (state, action) => {
            state.shareData = action.payload;
        },
        setServerId: (state, action) => {
            state.serverId = action.payload;
        },
        setItemInfo: (state, action) => {
            state.itemInfo = action.payload;
        },
        setSkillInfo: (state, action) => {
            state.skillInfo = action.payload;
        },
    },
});

export const { setDetailNow, setDetailId, setDetailEnchant, setDetailSvr, setShareData, setServerId, setItemInfo, setSkillInfo } =
    detailSlice.actions;

export default detailSlice.reducer;
